import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderService, CatalogService, AuthenticationService, UtilsService } from 'src/app/_services';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BasketProduct, BasketPrice, Product, Delivery, UserAddress, PickUpCenter } from 'src/app/_models';
import { BasketService } from 'src/app/_services/basket.service';
import { ProductDetailModalComponent } from 'src/app/products/product-detail-modal/product-detail-modal.component';

declare const $ : any;

@Component({
  selector: 'app-cart-payment-success',
  templateUrl: './cart-payment-success.component.html',
  styleUrls: ['./cart-payment-success.component.css']
})
export class CartPaymentSuccessComponent implements OnInit {


  public products : BasketProduct[];
  public basketPrice : BasketPrice;
  public delivery : Delivery;
  public deliveryAddress : UserAddress;
  public deliveryCenter : PickUpCenter;


  @ViewChild(ProductDetailModalComponent) productDetailModal: ProductDetailModalComponent; 

  
  constructor(
    public header : HeaderService,
    private auth : AuthenticationService,
    public translate : TranslateService,
    public catalog : CatalogService,
    public router : Router,
    public dom : DomSanitizer,
    private basket : BasketService,
    public utils : UtilsService
  ) { 
    this.header.setHeader(false,false,true, true);
  }

  ngOnInit() {

    this.products = this.basket.getLocalBasketProducts();
    this.basketPrice = this.basket.getLocalBasketPrice();
    this.delivery = this.basket.getLocalDelivery();
    this.deliveryAddress = null;
    this.deliveryCenter = null;


    if (this.delivery){
      if (this.delivery.tipo == 1){
        this.deliveryAddress = this.auth.currentUserValue.user_addresses.find(address =>{
          return address.recid == this.delivery.id_tipo
        });
      }
      if (this.delivery.tipo == 2){
        this.utils.getPickUpCenters().subscribe(result =>{
          this.deliveryCenter = result.find(center =>{
            return center.centerid == this.delivery.id_tipo;
          }); 
        });
      }
    }
    //20250602 axa inici
    this.auth.logout();
    //20250602 axa final
  }

  productDetail(itemId : string){
    $('#modal-product-detail').modal('show');
    this.productDetailModal.itemId = itemId;
    this.productDetailModal.loadData();
  }

}
